import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { InstallerSummary } from '../types/installer-summary-type';
import { LocationSummary } from '../types/location-summary-type';
import { OfficeSummary } from '../types/office-summary-type';
import { Shipment } from '../types/shipment';
import { InstallationCompany } from '../types/installation-companies'

@Component({
  selector: 'stock-summary',
  templateUrl: './stock-summary.component.html',
  styleUrls: ['./stock-summary.component.css'],
  providers: [HubService],
})

export class StockSummaryComponent implements OnInit {

  errorMessage: string;
  installerSummary = <InstallerSummary[]>[];
  locationSummary = <LocationSummary[]>[];
  officeSummary = <OfficeSummary[]>[];
  shipmentList = <Shipment[]>[];
  companyList = <InstallationCompany[]>[];

  constructor(
    private hubService: HubService,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }

    this.hubService.getInstallerSummary().subscribe(
      installerSummary => this.installerSummary = <InstallerSummary[]>installerSummary,
      error => this.errorMessage = <any>error,
    );

    this.hubService.getOfficeSummary().subscribe(
      officeSummary => this.officeSummary = <OfficeSummary[]>officeSummary,
      error => this.errorMessage = <any>error,
    );

    this.hubService.getLocationSummary().subscribe(
      locationSummary => this.locationSummary = <LocationSummary[]>locationSummary,
      error => this.errorMessage = <any>error,
    );

    this.hubService.getLookupTable('shipment').subscribe(
      lookup_values => this.shipmentList = <Shipment[]>lookup_values,
      error => this.errorMessage = <any>error,
    );

    this.hubService.getLookupTable('companies_table').subscribe(
      lookup_values => this.companyList = <InstallationCompany[]>lookup_values,
      error => this.errorMessage = <any>error,
    );
  }

  noNulls(one: any, two: any): string {
    if (one == null) {
      return two;
    }
    return one;
  }

  checkZero(zero: number): number {
    if (zero == null) {
      return 0;
    }
    return zero;
  }

  calTotalLoc(shipment: number): number{
    var total = 0;
    for(var i =0; i<this.locationSummary.length; i++){
      if(shipment == this.locationSummary[i].shipment_number){
        total += this.locationSummary[i].unit_count
      }
    }
    return total;
  }

  calTotalOffice(shipment: number): number{
    var total = 0;
    for(var i =0; i<this.officeSummary.length; i++){
      if(shipment == this.officeSummary[i].shipment_number){
        total += this.officeSummary[i].unit_count;
      }
    }
    return total;
  }

  calTotalCompany(shipment: number, company: number):string{
    var totalAvailable = 0;
    var totalInstalled = 0;

    for(var i=0; i<this.installerSummary.length; i++){
      if(shipment == this.installerSummary[i].installed_shipment_number && (company == this.installerSummary[i].installed_company_id || company == this.installerSummary[i].available_company_id)){      
        if(this.installerSummary[i].available_unit_count != null){
          totalAvailable += this.installerSummary[i].available_unit_count;
        }
        if(this.installerSummary[i].installed_unit_count != null){
          totalInstalled += this.installerSummary[i].installed_unit_count;
        }
      }
    }

    return `Total Available: ${totalAvailable}\nTotal Installed: ${totalInstalled}`;//put in inner text
  }

}

